import {
  useCurrentProperty,
  useCurrentPropertyId,
  useMediaFiles,
} from "@hooks/useSurveySelectors";
import FileGallery from "./FileGallery";
import PropertyDetailAddressForm from "./PropertyDetailAddressForm";
import PropertyDetailHeaderForm from "./PropertyDetailHeaderForm";
import PropertyInfoForm from "./PropertyInfoForm";

const PropertyDetailForm = () => {
  const currentPropertyId = useCurrentPropertyId();
  const currentProperty = useCurrentProperty();
  const allMediaFiles = useMediaFiles();

  // Only render children if we have a valid property selected
  if (!currentPropertyId || !currentProperty) {
    return null;
  }

  // Filter media files for the current property only
  const currentPropertyMedia = allMediaFiles?.[currentPropertyId] || null;

  return (
    <div className="flex flex-col">
      <div key={currentPropertyId} className="contents">
        {/* Sticky header — stays pinned to the top of the side-sheet scroll area */}
        <div className="sticky top-0 z-10 bg-white px-6 pt-6 pb-4 border-b border-slate-100">
          <PropertyDetailHeaderForm
            property={currentProperty}
            propertyId={currentPropertyId}
          />
        </div>

        {/* Scrollable form content */}
        <div className="px-6 pt-6 pb-8 flex flex-col gap-y-8">
          <PropertyDetailAddressForm
            property={currentProperty}
            propertyId={currentPropertyId}
          />
          <FileGallery
            propertyId={currentPropertyId}
            propertyMedia={currentPropertyMedia}
          />
          <div className="property-info-section-container grid grid-flow-row gap-6">
            <h2 className="text-xl text-data">Property Information</h2>
            <div className="grid grid-flow-row lg:grid-cols-2 gap-6 sm:grid-cols-1 items-start">
              <PropertyInfoForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetailForm;
